import axios from 'axios';

export const POST_REMOTE_SUCCESS = 'POST_REMOTE_SUCCESS';
export const POST_REMOTE_FAILURE = 'POST_REMOTE_FAILURE';
export const POST_REMOTE_STARTED = 'POST_REMOTE_STARTED';

export const postRemote = (contractId) => {
  return (dispatch) => {
    dispatch(postRemoteStarted());

    axios.post(`/contracts/${contractId}/set-remote/`, { contract_id: contractId })
      .then(({ data }) => {
        dispatch(postRemoteSuccess(data.remote_code ? true : false))
      })
      .catch((err) => {
        dispatch(postRemoteFailure(err.response.data.ui_message));
      })
  }
}

const postRemoteSuccess = (code) => ({
  type: POST_REMOTE_SUCCESS,
  payload: code,
});

const postRemoteFailure = (error) => ({
  type: POST_REMOTE_FAILURE,
  payload: error,
});

const postRemoteStarted = () => ({ type: POST_REMOTE_STARTED });

export default function remoteReducer(state, action) {
  switch (action.type) {
    case POST_REMOTE_STARTED:
      return {
        ...state,
        loading: true,
      }
    case POST_REMOTE_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case POST_REMOTE_SUCCESS:
      return {
        ...state,
        loading: false,
        remoteCode: action.payload,
        showRemoteSuccess: true,
      }
    default:
      return state;
  }
}
